export default "__VITE_ASSET__DPIyU3ei__"